import React from 'react';
import { Container } from 'react-bootstrap';

const stats = [
  { value: '2020', label: 'Built from the ground up' },
  { value: '3 years', label: 'Zero to full marketplace operation' },
  { value: '8+', label: 'Sales channels activated' },
  { value: '30K+', label: 'SKUs managed across channels' }
];

const TopiczStory = () => {
  return (
    <section className="wn-section" id="story">
      <Container>
        <div className="text-center wn-fade-in">
          <div
            className="wn-section-label"
            style={{ justifyContent: 'center' }}
          >
            <span className="label-dot" />
            Why We Do This
          </div>
          <h2 className="wn-section-title centered">
            We didn't read about this transformation.{' '}
            <span className="wn-gradient-text">We built it.</span>
          </h2>
        </div>

        <div className="wn-story-body wn-fade-in wn-fade-in-delay-1">
          <p>
            In the spring of 2020, we partnered with <strong>Topicz</strong> — a
            multigenerational family distribution business in Cincinnati ready
            to step into the information age.
          </p>
          <p>
            They had decades of distribution experience, deep customer
            relationships, and national brand access.
          </p>
          <p>What they didn't have was ecommerce infrastructure.</p>
          <p>
            No marketplace operation. No digital playbook. No foundation to
            build on.
          </p>
          <p>So we built it from the ground up.</p>
          <p>
            Over the next three years, we helped take Topicz from zero ecommerce
            capability to a fully operational, multi-marketplace business — then
            evolved that foundation into a marketplace management accelerator
            for nationally distributed CPG brands.
          </p>
          <p>
            Today, that operation activates and manages products across Amazon,
            Walmart.com, TikTok Shop, Temu, RepRally, Faire, Shopify, and more.
          </p>
          <p>
            We built the technology stack. We built the operating systems. We
            built the workflows, integrations, reporting, catalog
            infrastructure, and marketplace processes required to make it run.
          </p>
          <p className="wn-story-kicker">
            That is the work we do for you. Not a slide deck. Not theory. We
            have sat inside a legacy distributor, in the operator's chair, and
            helped build the future of one from the inside out. And we can do
            the same for yours.
          </p>
        </div>

        <div className="wn-story-stats wn-fade-in wn-fade-in-delay-2">
          {stats.map((s, i) => (
            <div key={i} className="wn-story-stat">
              <div className="metric-value">{s.value}</div>
              <div className="metric-label">{s.label}</div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default TopiczStory;
